import React from "react";
import { MenuItem, TextField } from "@mui/material";
import { UNFILED } from "../helper/projects";

/** The "no filter" value of the project dropdown. */
export const ALL_PROJECTS = "";

/**
 * The project dropdown of the overview lists: all projects, the unfiled
 * items only, or one project. Filtering is the page's job (client-side on
 * ``row.project``), this is the control alone.
 */
export default function ProjectFilterSelect({ projects, value, onChange, sx }) {
    return (
        <TextField
            select
            size="small"
            label="Project"
            value={value}
            onChange={(event) => onChange(event.target.value)}
            // ALL_PROJECTS is the empty string, so the label has to be pinned
            // shrunk and the empty value rendered explicitly.
            SelectProps={{ displayEmpty: true }}
            InputLabelProps={{ shrink: true }}
            sx={{ minWidth: 200, ...(sx || {}) }}
        >
            <MenuItem value={ALL_PROJECTS}>
                <em>All projects</em>
            </MenuItem>
            <MenuItem value={UNFILED}>
                <em>No project</em>
            </MenuItem>
            {(projects || []).map((project) => (
                <MenuItem key={project.id} value={project.id}>
                    {project.name}
                </MenuItem>
            ))}
        </TextField>
    );
}

/** Whether ``row`` passes the project filter ``value``. */
export function matchesProjectFilter(row, value) {
    if (value === ALL_PROJECTS) return true;
    if (value === UNFILED) return !row.project;
    return row.project === value;
}
